import { Shape, s } from "@kosmod/pancake";
import { Mini, miniDef } from "./mini";
import { ID, idDef } from "@kosmod/kit";
import { Surface, SurfaceID } from "./surface";
import { PhysicsDice } from "./dice";
import { GameID } from "@kosmod/sesame";
import { TerrainBrushID } from "./terrainBrush";

export type TerrainCanvasID = ID<"terrain_canvas", true>;
export const TerrainCanvasID = s.ref<TerrainCanvasID>()(idDef);
// export const getTerrainCanvasID = (surfaceId: SurfaceID, system: string) => surfaceId + ':' + system as TerrainCanvasID;

export type SceneID = ID<"scene", true>;
export const SceneID = s.ref<SceneID>()(idDef);

export type TerrainChunk = {
  canvas: TerrainCanvasID,
  x: number,
  y: number,
  /**
   * The height/width of a chunk should be known at canvas level.
   * 
   * A 3x3 chunk is laid out as such:
   * ```
   * 1 2 3
   * 4 5 6
   * 7 8 9
   * ```
   */
  data: number[],
}
export const TerrainChunk = s.ref<TerrainChunk>()(s.o({
  canvas: TerrainCanvasID,
  x: s.num,
  y: s.num,
  data: s.a(s.num),
}));
export const TerrainChunkList = s.o({
  game: GameID,
  canvas: TerrainCanvasID,
  scene: SceneID,

  chunks: s.a(TerrainChunk),
});
export type TerrainChunkList = Shape.Type.Of<typeof TerrainChunkList>;

/**
 * Very similar to a normal TerrainChunk, but exists only
 * client side as a computed version of
 * some other set of data/chunks.
 */
export type ComputedTerrainChunk = {
  x: number,
  y: number,
  data: number[],
}

export const TerrainChunkEvent = s.du('type', {
  'modify': { data: s.a(s.num) }
})
export type TerrainChunkEvent = Shape.Type.Of<typeof TerrainChunkEvent>

export type TerrainCanvas = {
  id: TerrainCanvasID,
  // system: string,
  surface: SurfaceID,
  palette: TerrainBrushID[]
}
export const TerrainCanvas = s.ref<TerrainCanvas>()(s.o({
  id: TerrainCanvasID,
  // system: s.str,
  surface: SurfaceID,
  palette: s.a(TerrainBrushID)
}));


export const sceneDef = s.ref<Scene>()(s.o({
  id: idDef,
  game: GameID,

  defaultSurface: SurfaceID,
  
  minis: s.a(miniDef),
  surfaces: s.a(Surface),
  canvases: s.a(TerrainCanvas),
  chunks: s.a(TerrainChunk),
  dice: s.a(PhysicsDice),
}));
export const Scene = sceneDef;

export type Scene = {
  id: SceneID,
  game: GameID,

  defaultSurface: SurfaceID,

  minis: Mini[],
  surfaces: Surface[],
  canvases: TerrainCanvas[],
  chunks: TerrainChunk[],
  dice: PhysicsDice[],
}
